import React from 'react';

/**
 * Unified page wrapper for all /app/* routes — consistent padding, max-width, footer spacing.
 */
export default function DashboardLayout({
  children,
  noPad = false,
  maxWidth = 'max-w-[1480px]',
  className = '',
  narrow = false,
}) {
  const width = narrow ? 'max-w-[1100px]' : maxWidth;
  return (
    <div
      className={`w-full min-w-0 max-w-full overflow-x-hidden ${width} mx-auto ${noPad ? '' : 'px-6 py-6 lg:px-8 lg:py-8'} ${className}`}
    >
      {children}
    </div>
  );
}
